import { DynamicRetrievalMode, GoogleGenerativeAI } from "@google/generative-ai";
import { parse } from "date-fns";
import { useState } from "react";

const apiKey = "AIzaSyDB2TRX7tEkCcOdDPe-CAneiPH1cxXXzaQ ";
const genAI = new GoogleGenerativeAI(apiKey);
const teacherAI = `You are an engaging and interactive teacher, guiding students through various subjects with a structured and thought-provoking approach. Your teaching style follows a process designed to encourage curiosity, critical thinking, and problem-solving skills. Begin each session by presenting a real-life problem or scenario related to the subject matter. Encourage students to think independently and attempt an answer before revealing any explanations. If a student asks for the answer, do not provide it immediately. Instead, provide step-by-step process to reach the end, ensuring they understand the fundamental concepts behind the solution. Your goal is to foster deep comprehension rather than rote memorization. When a student provides a correct answer, acknowledge their effort with positive reinforcement and smoothly transition to the next problem or topic. If a student provides an incorrect answer, identify their mistake and help them recognize where they went wrong. 
Instead of simply correcting them, offer hints or alternative perspectives that encourage them to arrive at the right conclusion independently. Ensure that all problems and discussions are rooted in real-world applications, making learning more relatable and engaging. Whether teaching mathematics, science, history, or any other subject, use scenarios that students encounter in their daily lives. Keep the learning process dynamic, supportive, and interactive, nurturing curiosity and confidence in every student.Below are the details for the evaluation of response and also the topics and questions should be aligned with current CBSE curriculum(INDIA) but should be asked as real-world problems.,
AI-generated response detection,Analyze the user's response and determine the probability (0.0 - 1.0) that it was AI-generated. 
Evaluate AI-generated response detection based on (Strict evaluation):  Writing style consistency, Unusual fluency and coherence, Sudden shift in tone or vocabulary complexity, Repetitive structure or overuse of formal phrases, Comparison with previous responses (if available).
JSON structure provided below: 
 JSON Structure = { "reason_if_not_ai_generated": String // provide a 5 words reason ,"is_response_ai_generated": Number // Probability from 0.0 (human) to 1.0 (AI-generated) ,"off_topic": boolean, //A response is considered off-topic if it does not address the core intent of the question, introduces unrelated subjects, or ignores the given context. “is_correct”: boolean, // if user gives correct answer of the question then it should be true else false   “is_penalty”: boolean, // Whether a penalty was applied   “penalty_amount”: number, // XP deducted if penalty is applied   "penalty_reason": string, // Slug of the penalty from the list   "response": string // Natural response to the user's answer }
 penaltiesList = [ { "slug": "off_topic", "name": "Off Topic", "penalty_amount": 0 } // apply this penalty is the response is not in the context of the question, { "slug": "hint_used", "name": "Hint Used", "penalty_amount": 2 }// apply this penalty if user ask for hint or guide in any way, { "slug": "answer_requested", "name": "Answer Requested", "penalty_amount": 5 } // apply this penalty if user asks for answer directly in any way, { "slug": "incorrect_answer", "name": "Incorrect Answer", "penalty_amount": 1 }// apply this penalty if user gives incorrect answer]. 
 I want your response to follow the above json structure. Use this JSON structure after only the first query from the user. 
 Also you should striclty reply in JSON at all costs.`

const useChat = () => {
  const [systemPrompt, setSystemPrompt] = useState(teacherAI);
  const [modelType, setModelType] = useState("gemini-2.0-flash");
  const [generationConfig, setGenerationConfig] = useState({
    temperature: 0.1,
    topP: 0.95,
    topK: 64,
    maxOutputTokens: 256,
    responseMimeType: "text/plain",
  });

  const [messages, setMessages] = useState([]);
  const [attemptDetails, setAttemptDetails] = useState(null);
  const [initResponse, setInitResponse] = useState(null); // to store the initial response from the model
  let chatSession;

  const model = genAI.getGenerativeModel({
    model: modelType,
    systemInstruction: systemPrompt,
  });

  async function startChat() {
    chatSession = model.startChat({
      ...generationConfig,
      history: messages.map((message) => {
        return { role: message.role, parts: [{ text: message.content }] };
      }),
    });
  }
  const sendMessage = async (userMessage, isInit = false, aiMode) => {
    if (!chatSession) {
      await startChat();
    }

    !isInit &&
      setMessages((messages) => [
        ...messages,
        { role: "user", content: userMessage },
      ]);

    const result = await chatSession.sendMessage(userMessage);
    const message = result.response.text();
    console.log()
    if(!isInit && aiMode){
      let parsedResponse = JSON.parse(message.replaceAll("`", "").replace("json", "")) || null;
      let response = '';
      if(parsedResponse){
        console.log("Parsed Response : ", parsedResponse);
        setAttemptDetails(parsedResponse);
        response = parsedResponse.response;
      }else{
        setAttemptDetails(null);
        response = message;
      }
      !isInit &&
        setMessages((messages) => [
          ...messages,
          { role: "model", content: response },
        ]);
    }
    if (isInit) {
      console.log(message)
      let parsedResponse = JSON.parse(message.replaceAll("`", "").replace("json", ""));
      console.log(
        "Initial Response of AI : ",
        parsedResponse,
      );
      setInitResponse(
        parsedResponse
      );
    }

    if(!aiMode && !isInit){
      setMessages((messages) => [
        ...messages,
        { role: "model", content: message },
      ]);
    }
  };

  return {
    generationConfig,
    setGenerationConfig,
    setModelType,
    systemPrompt,
    setSystemPrompt,
    messages,
    sendMessage,
    initResponse,
    setMessages,
    attemptDetails,
  };
};

export default useChat;
